import { useDispatch, useSelector } from "react-redux";
import PageContainer from "../components/PageContainer"
import PageTitle from "../components/PageTitle"
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import CustomHr from "../components/CustomHr";
import { setBacklink } from "../redux/backlinkSlice";
import QuillTranslationTextarea from "../components/QuillTranslationTextarea";
import Loader from '../components/Loader';
import Error from '../components/Error';
import { GreenButton } from '../components/buttons';

const HandleActivityTranslation = () => {

    // Catturo i dati dell'attività da Redux e li salvo in uno stato
    const [searchParams] = useSearchParams();
    const activityId = searchParams.get("activityId");
    const { data } = useSelector(state => state.adminActivities)
    const [activityFields, setActivityFields] = useState(null);
    useEffect(() => {
        if (data && data.length > 0) {
            data.forEach(element => {
                if (element._id === activityId) {
                    setActivityFields({
                        title: element.title,
                        summary: element.summary,
                        description: element.description,
                        priceNote: element.priceNote,
                        program: element.program,
                        servicesIncluded: element.servicesIncluded,
                        accessibility: element.accessibility,
                        cancellation: element.cancellation,
                        equipmentRentInfo: element.equipmentRentInfo,
                        onsiteEquipment: element.onsiteEquipment,
                        precautions: element.precautions,
                        technical: element.technical,
                        tags: element.tags,
                        customOptions: element.customOptions
                    })
                }
            });
        }
    }, [data])

    // Imposto il backlink
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(setBacklink(`/add-edit-activity?activityId=${activityId}`))
    }, [activityId])

    // Ricevo i dati delle traduzioni se presenti
    useEffect(() => {
        if (activityId) getDocument();
    }, [activityId])
    const token = localStorage.getItem('ticino-wild-token')
    const [documentData, setDocumentData] = useState(null);
    const [getStatus, setGetStatus] = useState('idle');
    const [getError, setGetError] = useState(null);
    const getDocument = async () => {
        setGetStatus('loading');
        const url = `${process.env.REACT_APP_SERVER_BASE_URL}/activity-translations/get-document/${activityId}`
        const headers = { 'Cotnent-Type': 'application/json', Authorization: `Bearer ${token}` };
        const options = { method: 'GET', headers };
        try {
            const response = await fetch(url, options);
            if (response.ok) {
                const result = await response.json();
                setDocumentData(result.payload);
                setGetStatus('succeeded');
            } else {
                const error = await response.json();
                throw new Error(error)
            }
        } catch (error) {
            console.error(error)
            setGetError(error.message || "Errore nel ricevere il documento delle traduzioni. Ricarica la pagina e riprova");
            setGetStatus('failed');
        }
    }

    // Gestisco l'input utente per creare 'newData' da mandare in backend
    const handleDocumentData = (event) => {
        const { id, value } = event.target;
        const [field, lang, index, title, subIndex] = id.split('-');
        setDocumentData(prevState => {
            // Se c'è index stiamo gestendo un array
            if (index) {
                if (!title) {
                    // Faccio una copia dell'array esistente
                    const currentArray = [...prevState[field][lang]];
                    // Aggiorno il valore all'indice specificato
                    currentArray[index] = value;
                    return {
                        ...prevState,
                        [field]: {
                            ...prevState[field],
                            [lang]: currentArray
                        }
                    }
                } else {
                    if (subIndex) {
                        // Se c'è il subIndex è la traduzione di un valore di customOptions[index].values[lang]
                        // Mi assicuro che customOptions esista
                        const customOptions = Array.isArray(prevState.customOptions)
                            ? [...prevState.customOptions]
                            : [];
                        // Riempio l'array con oggetti vuoti fino all'indice richiesto
                        const indexNum = parseInt(index);
                        while (customOptions.length <= indexNum) {
                            customOptions.push({
                                title: { en: "", fr: "", de: "" },
                                values: { en: [], fr: [], de: [] }
                            });
                        }
                        // Se l'oggetto values non esiste, lo creo
                        if (!customOptions[indexNum].values) {
                            customOptions[indexNum].values = { en: [], fr: [], de: [] };
                        }
                        // Se l'array per la lingua specificata non esiste, lo creo
                        if (!Array.isArray(customOptions[indexNum].values[lang])) {
                            customOptions[indexNum].values[lang] = [];
                        }
                        // Copio l'array esistente per la lingua
                        const valuesArray = [...customOptions[indexNum].values[lang]];
                        // Riempio l'array con stringhe vuote fino all'indice richiesto
                        const subIndexNum = parseInt(subIndex);
                        while (valuesArray.length <= subIndexNum) {
                            valuesArray.push("");
                        }
                        // Aggiorno il valore all'indice specificato
                        valuesArray[subIndexNum] = value;
                        // Aggiorno l'array dei valori
                        customOptions[indexNum].values[lang] = valuesArray;
                        return {
                            ...prevState,
                            customOptions
                        };
                    } else {
                        // È una traduzione del titolo di customOptions[index].title[lang]
                        // Mi assicuro che customOptions esista
                        const customOptions = Array.isArray(prevState.customOptions)
                            ? [...prevState.customOptions]
                            : [];
                        // Riempio l'array con oggetti vuoti fino all'indice richiesto
                        const indexNum = parseInt(index);
                        while (customOptions.length <= indexNum) {
                            customOptions.push({
                                title: { en: "", fr: "", de: "" },
                                values: { en: [], fr: [], de: [] }
                            });
                        }
                        // Se l'oggetto title non esiste, lo creo
                        if (!customOptions[indexNum].title) {
                            customOptions[indexNum].title = { en: "", fr: "", de: "" };
                        }
                        // Aggiorno il valore del titolo per la lingua specificata
                        customOptions[indexNum].title[lang] = value;
                        return {
                            ...prevState,
                            customOptions
                        };
                    }
                }
            } else {
                // Altrimenti gestisco una stringa normale
                return {
                    ...prevState,
                    [field]: {
                        ...prevState[field], // mantiene gli altri valori lingua se esistono
                        [lang]: value
                    }
                }
            }
        })
    }

    // Invio il newDocument al backend
    const navigate = useNavigate();
    const { link } = useSelector(state => state.backlink);
    const [sendStatus, setSendStatus] = useState('idle');
    const [sendError, setSendError] = useState(null);
    const sendNewData = async () => {
        setSendStatus('loading');
        const url = `${process.env.REACT_APP_SERVER_BASE_URL}/activity-translations/set-new-translation-fields`;
        const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
        const options = { method: 'POST', headers, body: JSON.stringify({ newData: documentData }) };
        try {
            const response = await fetch(url, options);
            if (response.ok) {
                setSendStatus('succeeded');
                setTimeout(() => {
                    navigate('/handle-activities')
                }, 3000)
            } else {
                const error = await response.json();
                throw new Error(error);
            }
        } catch (error) {
            setSendError(error.message || "Errore nell'inviare il documenti delle traduzioni.");
            setSendStatus('failed')
        }
    }

    return (
        <PageContainer desktopItems="center">
            <PageTitle title="Gestisci le traduzioni dell'attività" />
            {getStatus === 'loading' && <Loader />}
            {getStatus === 'failed' && <Error message={getError} />}
            {
                getStatus === 'succeeded' && activityFields && documentData &&
                <div className="flex flex-col gap-16">
                    {/* Title */}
                    {
                        activityFields && activityFields.title &&
                        <div className="w-full lg:w-[800px] flex flex-col gap-2">
                            <CustomHr />
                            <h3>Titolo</h3>
                            <div className="w-full">
                                <div className="text-2xl">🇮🇹</div>
                                <h4>{activityFields.title}</h4>
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇬🇧</div>
                                <input className="w-full" type="text" id="title-en" value={documentData.title.en} onChange={handleDocumentData} />
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇫🇷</div>
                                <input className="w-full" type="text" id="title-fr" value={documentData.title.fr} onChange={handleDocumentData} />
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇩🇪</div>
                                <input className="w-full" type="text" id="title-de" value={documentData.title.de} onChange={handleDocumentData} />
                            </div>
                        </div>
                    }

                    {/* Summary */}
                    {
                        activityFields && activityFields.summary &&
                        <div className="w-full lg:w-[800px] flex flex-col gap-2">
                            <CustomHr />
                            <h3>Sommario</h3>
                            <div className="w-full">
                                <div className="text-2xl">🇮🇹</div>
                                <h4>{activityFields.summary}</h4>
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇬🇧</div>
                                <input className="w-full" type="text" id="summary-en" value={documentData.summary.en} onChange={handleDocumentData} />
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇫🇷</div>
                                <input className="w-full" type="text" id="summary-fr" value={documentData.summary.fr} onChange={handleDocumentData} />
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇩🇪</div>
                                <input className="w-full" type="text" id="summary-de" value={documentData.summary.de} onChange={handleDocumentData} />
                            </div>
                        </div>
                    }

                    {/* Decription */}
                    {
                        activityFields && activityFields.description &&
                        <div className="w-full lg:w-[800px] flex flex-col gap-2">
                            <CustomHr />
                            <h3>Descrizione</h3>
                            <div className="w-full">
                                <div className="text-2xl">🇮🇹</div>
                                <div dangerouslySetInnerHTML={{ __html: activityFields.description }}></div>
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇬🇧</div>
                                {/* <input className="w-full" type="text" id="description-en" value={documentData.description.en} onChange={handleDocumentData} /> */}
                                <QuillTranslationTextarea initContent={documentData.description.en} setInputData={setDocumentData} id="en" />
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇫🇷</div>
                                {/* <input className="w-full" type="text" id="description-fr" value={documentData.description.fr} onChange={handleDocumentData} /> */}
                                <QuillTranslationTextarea initContent={documentData.description.fr} setInputData={setDocumentData} id="fr" />
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇩🇪</div>
                                {/* <input className="w-full" type="text" id="description-de" value={documentData.description.de} onChange={handleDocumentData} /> */}
                                <QuillTranslationTextarea initContent={documentData.description.de} setInputData={setDocumentData} id="de" />
                            </div>
                        </div>
                    }

                    {/* priceNote */}
                    {
                        activityFields && activityFields.priceNote &&
                        <div className="w-full lg:w-[800px] flex flex-col gap-2">
                            <CustomHr />
                            <h3>Note sul prezzo</h3>
                            <div className="w-full">
                                <div className="text-2xl">🇮🇹</div>
                                <h4>{activityFields.priceNote}</h4>
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇬🇧</div>
                                <input className="w-full" type="text" id="priceNote-en" value={documentData.priceNote.en} onChange={handleDocumentData} />
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇫🇷</div>
                                <input className="w-full" type="text" id="priceNote-fr" value={documentData.priceNote.fr} onChange={handleDocumentData} />
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇩🇪</div>
                                <input className="w-full" type="text" id="priceNote-de" value={documentData.priceNote.de} onChange={handleDocumentData} />
                            </div>
                        </div>
                    }


                    {/* Array */}
                    {/* Program */}
                    {
                        activityFields.program && activityFields.program.length > 0 &&
                        <div className="w-full lg:w-[800px] flex flex-col gap-2">
                            <CustomHr />
                            <h3>Programma</h3>
                            <div className="w-full">
                                <div className="text-2xl">🇮🇹</div>
                                <ul>
                                    {
                                        activityFields.program.map((element, index) => {
                                            return <li key={index}>{element}</li>
                                        })
                                    }
                                </ul>
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇬🇧</div>
                                {
                                    activityFields.program.map((element, index) => {
                                        return <input key={index} type="text" id={`program-en-${index}`} className="w-full mb-2" value={documentData.program.en[index]} onChange={handleDocumentData} />
                                    })
                                }
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇫🇷</div>
                                {
                                    activityFields.program.map((element, index) => {
                                        return <input key={index} type="text" id={`program-fr-${index}`} className="w-full mb-2" value={documentData.program.fr[index]} onChange={handleDocumentData} />
                                    })
                                }
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇩🇪</div>
                                {
                                    activityFields.program.map((element, index) => {
                                        return <input key={index} type="text" id={`program-de-${index}`} className="w-full mb-2" value={documentData.program.de[index]} onChange={handleDocumentData} />
                                    })
                                }
                            </div>
                        </div>
                    }

                    {/* ServicesIncluded */}
                    {
                        activityFields.servicesIncluded && activityFields.servicesIncluded.length > 0 &&
                        <div className="w-full lg:w-[800px] flex flex-col gap-2">
                            <CustomHr />
                            <h3>Servizi inclusi</h3>
                            <div className="w-full">
                                <div className="text-2xl">🇮🇹</div>
                                <ul>
                                    {
                                        activityFields.servicesIncluded.map((element, index) => {
                                            return <li key={index}>{element}</li>
                                        })
                                    }
                                </ul>
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇬🇧</div>
                                {
                                    activityFields.servicesIncluded.map((element, index) => {
                                        return <input key={index} type="text" id={`servicesIncluded-en-${index}`} className="w-full mb-2" value={documentData.servicesIncluded.en[index]} onChange={handleDocumentData} />
                                    })
                                }
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇫🇷</div>
                                {
                                    activityFields.servicesIncluded.map((element, index) => {
                                        return <input key={index} type="text" id={`servicesIncluded-fr-${index}`} className="w-full mb-2" value={documentData.servicesIncluded.fr[index]} onChange={handleDocumentData} />
                                    })
                                }
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇩🇪</div>
                                {
                                    activityFields.servicesIncluded.map((element, index) => {
                                        return <input key={index} type="text" id={`servicesIncluded-de-${index}`} className="w-full mb-2" value={documentData.servicesIncluded.de[index]} onChange={handleDocumentData} />
                                    })
                                }
                            </div>
                        </div>
                    }
                    {/* Accessibility */}
                    {
                        activityFields.accessibility && activityFields.accessibility.length > 0 &&
                        <div className="w-full lg:w-[800px] flex flex-col gap-2">
                            <CustomHr />
                            <h3>Accessibilità</h3>
                            <div className="w-full">
                                <div className="text-2xl">🇮🇹</div>
                                <ul>
                                    {
                                        activityFields.accessibility.map((element, index) => {
                                            return <li key={index}>{element}</li>
                                        })
                                    }
                                </ul>
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇬🇧</div>
                                {
                                    activityFields.accessibility.map((element, index) => {
                                        return <input key={index} type="text" id={`accessibility-en-${index}`} className="w-full mb-2" value={documentData.accessibility.en[index]} onChange={handleDocumentData} />
                                    })
                                }
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇫🇷</div>
                                {
                                    activityFields.accessibility.map((element, index) => {
                                        return <input key={index} type="text" id={`accessibility-fr-${index}`} className="w-full mb-2" value={documentData.accessibility.fr[index]} onChange={handleDocumentData} />
                                    })
                                }
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇩🇪</div>
                                {
                                    activityFields.accessibility.map((element, index) => {
                                        return <input key={index} type="text" id={`accessibility-de-${index}`} className="w-full mb-2" value={documentData.accessibility.de[index]} onChange={handleDocumentData} />
                                    })
                                }
                            </div>
                        </div>
                    }
                    {/* Cancellation */}
                    {
                        activityFields.cancellation && activityFields.cancellation.length > 0 &&
                        <div className="w-full lg:w-[800px] flex flex-col gap-2">
                            <CustomHr />
                            <h3>Cancellazione e rimborso</h3>
                            <div className="w-full">
                                <div className="text-2xl">🇮🇹</div>
                                <ul>
                                    {
                                        activityFields.cancellation.map((element, index) => {
                                            return <li key={index}>{element}</li>
                                        })
                                    }
                                </ul>
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇬🇧</div>
                                {
                                    activityFields.cancellation.map((element, index) => {
                                        return <input key={index} type="text" id={`cancellation-en-${index}`} className="w-full mb-2" value={documentData.cancellation.en[index]} onChange={handleDocumentData} />
                                    })
                                }
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇫🇷</div>
                                {
                                    activityFields.cancellation.map((element, index) => {
                                        return <input key={index} type="text" id={`cancellation-fr-${index}`} className="w-full mb-2" value={documentData.cancellation.fr[index]} onChange={handleDocumentData} />
                                    })
                                }
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇩🇪</div>
                                {
                                    activityFields.cancellation.map((element, index) => {
                                        return <input key={index} type="text" id={`cancellation-de-${index}`} className="w-full mb-2" value={documentData.cancellation.de[index]} onChange={handleDocumentData} />
                                    })
                                }
                            </div>
                        </div>
                    }
                    {/* EquipmentRentInfo */}
                    {
                        activityFields.equipmentRentInfo && activityFields.equipmentRentInfo.length > 0 &&
                        <div className="w-full lg:w-[800px] flex flex-col gap-2">
                            <CustomHr />
                            <h3>Noleggio attrezzatura</h3>
                            <div className="w-full">
                                <div className="text-2xl">🇮🇹</div>
                                <ul>
                                    {
                                        activityFields.equipmentRentInfo.map((element, index) => {
                                            return <li key={index}>{element}</li>
                                        })
                                    }
                                </ul>
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇬🇧</div>
                                {
                                    activityFields.equipmentRentInfo.map((element, index) => {
                                        return <input key={index} type="text" id={`equipmentRentInfo-en-${index}`} className="w-full mb-2" value={documentData.equipmentRentInfo.en[index]} onChange={handleDocumentData} />
                                    })
                                }
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇫🇷</div>
                                {
                                    activityFields.equipmentRentInfo.map((element, index) => {
                                        return <input key={index} type="text" id={`equipmentRentInfo-fr-${index}`} className="w-full mb-2" value={documentData.equipmentRentInfo.fr[index]} onChange={handleDocumentData} />
                                    })
                                }
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇩🇪</div>
                                {
                                    activityFields.equipmentRentInfo.map((element, index) => {
                                        return <input key={index} type="text" id={`equipmentRentInfo-de-${index}`} className="w-full mb-2" value={documentData.equipmentRentInfo.de[index]} onChange={handleDocumentData} />
                                    })
                                }
                            </div>
                        </div>
                    }
                    {/* OnsiteEquipment */}
                    {
                        activityFields.onsiteEquipment && activityFields.onsiteEquipment.length > 0 &&
                        <div className="w-full lg:w-[800px] flex flex-col gap-2">
                            <CustomHr />
                            <h3>Attrezzature presenti in loco</h3>
                            <div className="w-full">
                                <div className="text-2xl">🇮🇹</div>
                                <ul>
                                    {
                                        activityFields.onsiteEquipment.map((element, index) => {
                                            return <li key={index}>{element}</li>
                                        })
                                    }
                                </ul>
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇬🇧</div>
                                {
                                    activityFields.onsiteEquipment.map((element, index) => {
                                        return <input key={index} type="text" id={`onsiteEquipment-en-${index}`} className="w-full mb-2" value={documentData.onsiteEquipment.en[index]} onChange={handleDocumentData} />
                                    })
                                }
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇫🇷</div>
                                {
                                    activityFields.onsiteEquipment.map((element, index) => {
                                        return <input key={index} type="text" id={`onsiteEquipment-fr-${index}`} className="w-full mb-2" value={documentData.onsiteEquipment.fr[index]} onChange={handleDocumentData} />
                                    })
                                }
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇩🇪</div>
                                {
                                    activityFields.onsiteEquipment.map((element, index) => {
                                        return <input key={index} type="text" id={`onsiteEquipment-de-${index}`} className="w-full mb-2" value={documentData.onsiteEquipment.de[index]} onChange={handleDocumentData} />
                                    })
                                }
                            </div>
                        </div>
                    }
                    {/* Precautions */}
                    {
                        activityFields.precautions && activityFields.precautions.length > 0 &&
                        <div className="w-full lg:w-[800px] flex flex-col gap-2">
                            <CustomHr />
                            <h3>Avvertenze</h3>
                            <div className="w-full">
                                <div className="text-2xl">🇮🇹</div>
                                <ul>
                                    {
                                        activityFields.precautions.map((element, index) => {
                                            return <li key={index}>{element}</li>
                                        })
                                    }
                                </ul>
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇬🇧</div>
                                {
                                    activityFields.precautions.map((element, index) => {
                                        return <input key={index} type="text" id={`precautions-en-${index}`} className="w-full mb-2" value={documentData.precautions.en[index]} onChange={handleDocumentData} />
                                    })
                                }
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇫🇷</div>
                                {
                                    activityFields.precautions.map((element, index) => {
                                        return <input key={index} type="text" id={`precautions-fr-${index}`} className="w-full mb-2" value={documentData.precautions.fr[index]} onChange={handleDocumentData} />
                                    })
                                }
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇩🇪</div>
                                {
                                    activityFields.precautions.map((element, index) => {
                                        return <input key={index} type="text" id={`precautions-de-${index}`} className="w-full mb-2" value={documentData.precautions.de[index]} onChange={handleDocumentData} />
                                    })
                                }
                            </div>
                        </div>
                    }
                    {/* Technical */}
                    {
                        activityFields.technical && activityFields.technical.length > 0 &&
                        <div className="w-full lg:w-[800px] flex flex-col gap-2">
                            <CustomHr />
                            <h3>Dettagli tecnici</h3>
                            <div className="w-full">
                                <div className="text-2xl">🇮🇹</div>
                                <ul>
                                    {
                                        activityFields.technical.map((element, index) => {
                                            return <li key={index}>{element}</li>
                                        })
                                    }
                                </ul>
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇬🇧</div>
                                {
                                    activityFields.technical.map((element, index) => {
                                        return <input key={index} type="text" id={`technical-en-${index}`} className="w-full mb-2" value={documentData.technical.en[index]} onChange={handleDocumentData} />
                                    })
                                }
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇫🇷</div>
                                {
                                    activityFields.technical.map((element, index) => {
                                        return <input key={index} type="text" id={`technical-fr-${index}`} className="w-full mb-2" value={documentData.technical.fr[index]} onChange={handleDocumentData} />
                                    })
                                }
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇩🇪</div>
                                {
                                    activityFields.technical.map((element, index) => {
                                        return <input key={index} type="text" id={`technical-de-${index}`} className="w-full mb-2" value={documentData.technical.de[index]} onChange={handleDocumentData} />
                                    })
                                }
                            </div>
                        </div>
                    }
                    {/* Tags */}
                    {
                        activityFields.tags && activityFields.tags.length > 0 &&
                        <div className="w-full lg:w-[800px] flex flex-col gap-2">
                            <CustomHr />
                            <h3>Tag</h3>
                            <div className="w-full">
                                <div className="text-2xl">🇮🇹</div>
                                <ul>
                                    {
                                        activityFields.tags.map((element, index) => {
                                            return <li key={index}>{element}</li>
                                        })
                                    }
                                </ul>
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇬🇧</div>
                                {
                                    activityFields.tags.map((element, index) => {
                                        return <input key={index} type="text" id={`tags-en-${index}`} className="w-full mb-2" value={documentData.tags.en[index]} onChange={handleDocumentData} />
                                    })
                                }
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇫🇷</div>
                                {
                                    activityFields.tags.map((element, index) => {
                                        return <input key={index} type="text" id={`tags-fr-${index}`} className="w-full mb-2" value={documentData.tags.fr[index]} onChange={handleDocumentData} />
                                    })
                                }
                            </div>
                            <div className="w-full">
                                <div className="text-2xl">🇩🇪</div>
                                {
                                    activityFields.tags.map((element, index) => {
                                        return <input key={index} type="text" id={`tags-de-${index}`} className="w-full mb-2" value={documentData.tags.de[index]} onChange={handleDocumentData} />
                                    })
                                }
                            </div>
                        </div>
                    }
                    {/* CUSTOM OPTIONS */}
                    {
                        activityFields.customOptions && activityFields.customOptions.length > 0 &&
                        <div className="w-full lg:w-[800px] flex flex-col gap-2">
                            <CustomHr />
                            <h2>Opzioni personalizzate</h2>
                            {
                                activityFields.customOptions.map((element, index) => {
                                    return <div key={index} className="w-full">
                                        <CustomHr />
                                        <h3>Titolo opzione</h3>
                                        <div className="w-full">
                                            <div className="text-2xl">🇮🇹</div>
                                            <div>{element.title}</div>
                                        </div>
                                        <div>
                                            <div className="text-2xl">🇬🇧</div>
                                            <input key={index} type="text" id={`customOptions-en-${index}-${element.title}`} className="w-full mb-2" value={documentData.customOptions ? documentData.customOptions[index]?.title.en : ''} onChange={handleDocumentData} />
                                        </div>
                                        <div>
                                            <div className="text-2xl">🇫🇷</div>
                                            <input key={index} type="text" id={`customOptions-fr-${index}-${element.title}`} className="w-full mb-2" value={documentData.customOptions ? documentData.customOptions[index]?.title.fr : ''} onChange={handleDocumentData} />
                                        </div>
                                        <div>
                                            <div className="text-2xl">🇩🇪</div>
                                            <input key={index} type="text" id={`customOptions-de-${index}-${element.title}`} className="w-full mb-2" value={documentData.customOptions ? documentData.customOptions[index]?.title.de : ''} onChange={handleDocumentData} />
                                        </div>
                                        <h4>Valori opzione</h4>
                                        <div className="w-full">

                                            <div className="w-full">
                                                <div className="w-full">
                                                    <div className="text-2xl">🇮🇹</div>
                                                    <ul>
                                                        {
                                                        element.values.map((el, subIndex) => {
                                                            return <li>{el}</li>
                                                        })
                                                    }
                                                    </ul>
                                                    
                                                </div>
                                                <div className="w-full">
                                                    <div className="text-2xl">🇬🇧</div>
                                                    {
                                                        element.values.map((el, subIndex) => {
                                                            return <input key={index} type="text" id={`customOptions-en-${index}-${element.title}-${subIndex}`} className="w-full mb-2" value={documentData.customOptions ? documentData.customOptions[index]?.values.en[subIndex] : ''} onChange={handleDocumentData} />
                                                        })
                                                    }
                                                </div>
                                                <div className="w-full">
                                                    <div className="text-2xl">🇫🇷</div>
                                                    {
                                                        element.values.map((el, subIndex) => {
                                                            return <input key={index} type="text" id={`customOptions-fr-${index}-${element.title}-${subIndex}`} className="w-full mb-2" value={documentData.customOptions ? documentData.customOptions[index]?.values.fr[subIndex] : ''} onChange={handleDocumentData} />
                                                        })
                                                    }
                                                </div>
                                                <div className="w-full">
                                                    <div className="text-2xl">🇩🇪</div>
                                                    {
                                                        element.values.map((el, subIndex) => {
                                                            return <input key={index} type="text" id={`customOptions-de-${index}-${element.title}-${subIndex}`} className="w-full mb-2" value={documentData.customOptions ? documentData.customOptions[index]?.values.de[subIndex] : ''} onChange={handleDocumentData} />
                                                        })
                                                    }
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                })
                            }
                        </div>
                    }
                    {sendStatus === 'idle' && <GreenButton text="Invia traduzioni" click={sendNewData} />}
                    {sendStatus === 'loading' && <Loader />}
                    {sendStatus === 'failed' && <Error message={sendError} />}
                    {sendStatus === 'succeeded' && <h3>Traduzioni inviate correttamente. Attenti il refresh della pagina</h3>}
                </div>
            }
        </PageContainer>
    )
}

export default HandleActivityTranslation